import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Card } from '@material-ui/core';
//import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  body: {
    background: theme.palette.bgElements,
    minHeight: '50vh',
    padding: '10px 10px'
  },
  itemWrap: {
    fontWeight: 500
  },
  itemLabel: {
    fontWeight: 200
  }
}));

function Contact(props) {
  const { data, themeMode } = props;
  const classes = useStyles();

  if (data !== null) {
    return (
      <div className="table-responsive">
        <table
          className={clsx(
            'table',
            themeMode === 'night' && 'table-pts-night',
            themeMode === 'day' && 'table-pts-day',
            'text-nowrap',
            'mb-0'
          )}>
          <thead>
            <tr>
              <th className="bg-white">Contact Method</th>
              <th className="bg-white">Method Type</th>
              <th className="bg-white">Info</th>
              <th className="bg-white">Extension</th>
              <th className="bg-white text-center">Is Default</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => {
              return (
                <tr key={idx}>
                  <td>{row.ContactMethod}</td>
                  <td>{row.MethodType}</td>
                  <td>{row.Info}</td>
                  <td>{row.Extension}</td>
                  <td className="text-center">
                    <div
                      className={clsx(
                        'badge',
                        row.IsDefault === true &&
                          'bg-neutral-success text-success',
                        row.IsDefault === false &&
                          'bg-neutral-danger text-danger'
                      )}>
                      {row.IsDefault === true ? 'Yes' : 'No'}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  } else {
    return (
      <Card className="card-box bg-neutral-warning border-1 card-border-top border-warning text-center p-3">
        <h4 style={{ marginBottom: 0, color: 'black' }}>
          Sorry, no contacts found.
        </h4>
      </Card>
    );
  }
}

export default Contact;
